@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_678_552_531)
internal val Res.string.send_feedback_btn: StringResource by lazy {
      StringResource("string:send_feedback_btn", "send_feedback_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259784, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256428, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258335, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247304, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241188, 45),
      ))
    }

@delegate:ResourceContentHash(-181_869_703)
internal val Res.string.share_btn_text: StringResource by lazy {
      StringResource("string:share_btn_text", "share_btn_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259830, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256478, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258385, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247350, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241234, 30),
      ))
    }

@delegate:ResourceContentHash(1_749_830_961)
internal val Res.string.share_builder: StringResource by lazy {
      StringResource("string:share_builder", "share_builder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 259861, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256513, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258420, 217),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247385, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241265, 181),
      ))
    }

@delegate:ResourceContentHash(-44_191_995)
internal val Res.string.share_quiz_hiero: StringResource by lazy {
      StringResource("string:share_quiz_hiero", "share_quiz_hiero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 260075, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256711, 200),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258638, 204),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247575, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241447, 180),
      ))
    }

@delegate:ResourceContentHash(-495_771_486)
internal val Res.string.share_quiz_multi: StringResource by lazy {
      StringResource("string:share_quiz_multi", "share_quiz_multi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 260272, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 256912, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 258843, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247772, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241628, 160),
      ))
    }

@delegate:ResourceContentHash(-1_641_141_732)
internal val Res.string.share_quiz_spelling: StringResource by lazy {
      StringResource("string:share_quiz_spelling", "share_quiz_spelling", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 260437, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 257081, 187),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259020, 179),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 247941, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241789, 167),
      ))
    }

@delegate:ResourceContentHash(1_442_276_034)
internal val Res.string.share_quiz_transcribe: StringResource by lazy {
      StringResource("string:share_quiz_transcribe", "share_quiz_transcribe", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 260621, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 257269, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259200, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 248117, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241957, 181),
      ))
    }

@delegate:ResourceContentHash(-1_783_494_112)
internal val Res.string.share_quiz_translate: StringResource by lazy {
      StringResource("string:share_quiz_translate", "share_quiz_translate", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 260819, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 257459, 192),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259390, 200),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 248299, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242139, 184),
      ))
    }

@delegate:ResourceContentHash(-967_424_246)
internal val Res.string.share_quiz_true_false: StringResource by lazy {
      StringResource("string:share_quiz_true_false", "share_quiz_true_false", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261016, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 257652, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259591, 201),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 248484, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242324, 181),
      ))
    }

@delegate:ResourceContentHash(691_006_281)
internal val Res.string.share_quiz_word: StringResource by lazy {
      StringResource("string:share_quiz_word", "share_quiz_word", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261210, 183),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 257866, 183),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259793, 183),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 248686, 175),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242506, 175),
      ))
    }

@delegate:ResourceContentHash(1_450_246_609)
internal val Res.string.share_streak_many: StringResource by lazy {
      StringResource("string:share_streak_many", "share_streak_many", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261394, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258050, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 259977, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 248862, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242682, 181),
      ))
    }

@delegate:ResourceContentHash(1_600_395_747)
internal val Res.string.share_streak_one: StringResource by lazy {
      StringResource("string:share_streak_one", "share_streak_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261592, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258256, 200),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260191, 208),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249056, 192),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 242864, 180),
      ))
    }

@delegate:ResourceContentHash(655_846_410)
internal val Res.string.share_title: StringResource by lazy {
      StringResource("string:share_title", "share_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261789, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258457, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260400, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249249, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243045, 39),
      ))
    }

@delegate:ResourceContentHash(-439_843_673)
internal val Res.string.shop: StringResource by lazy {
      StringResource("string:shop", "shop", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261829, 20),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258501, 20),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260444, 24),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249293, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243085, 20),
      ))
    }

@delegate:ResourceContentHash(1_885_150_472)
internal val Res.string.stat_desc_coin: StringResource by lazy {
      StringResource("string:stat_desc_coin", "stat_desc_coin", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 261850, 250),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258522, 226),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260469, 242),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249318, 222),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243106, 226),
      ))
    }

@delegate:ResourceContentHash(126_604_018)
internal val Res.string.stat_desc_heart: StringResource by lazy {
      StringResource("string:stat_desc_heart", "stat_desc_heart", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262101, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258749, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260712, 179),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249541, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243333, 143),
      ))
    }

@delegate:ResourceContentHash(-2_011_920_042)
internal val Res.string.stat_desc_star: StringResource by lazy {
      StringResource("string:stat_desc_star", "stat_desc_star", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262253, 310),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258917, 322),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260892, 310),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249701, 294),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243477, 262),
      ))
    }

@delegate:ResourceContentHash(952_429_080)
internal val Res.string.stat_desc_strike: StringResource by lazy {
      StringResource("string:stat_desc_strike", "stat_desc_strike", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262564, 308),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259240, 224),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261203, 280),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 249996, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243740, 204),
      ))
    }

@delegate:ResourceContentHash(1_700_361_219)
internal val Res.string.stat_title_coin: StringResource by lazy {
      StringResource("string:stat_title_coin", "stat_title_coin", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262873, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259465, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261484, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250209, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243945, 31),
      ))
    }

@delegate:ResourceContentHash(81_209_900)
internal val Res.string.stat_title_heart: StringResource by lazy {
      StringResource("string:stat_title_heart", "stat_title_heart", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262905, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259497, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261516, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250245, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 243977, 32),
      ))
    }

@delegate:ResourceContentHash(-318_493_675)
internal val Res.string.stat_title_star: StringResource by lazy {
      StringResource("string:stat_title_star", "stat_title_star", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262938, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259534, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261549, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250278, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244010, 31),
      ))
    }

@delegate:ResourceContentHash(-547_479_087)
internal val Res.string.stat_title_strike: StringResource by lazy {
      StringResource("string:stat_title_strike", "stat_title_strike", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 262970, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259570, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261585, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250310, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244042, 33),
      ))
    }

@delegate:ResourceContentHash(-1_625_956_865)
internal val Res.string.streak_restoration_banner_hint: StringResource by lazy {
      StringResource("string:streak_restoration_banner_hint", "streak_restoration_banner_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263004, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259604, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250348, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244076, 94),
      ))
    }

@delegate:ResourceContentHash(-1_708_428_609)
internal val Res.string.streak_restoration_banner_many: StringResource by lazy {
      StringResource("string:streak_restoration_banner_many", "streak_restoration_banner_many", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263127, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259711, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250459, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244171, 98),
      ))
    }

@delegate:ResourceContentHash(220_684_101)
internal val Res.string.streak_restoration_banner_one: StringResource by lazy {
      StringResource("string:streak_restoration_banner_one", "streak_restoration_banner_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263234, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259814, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250550, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244270, 89),
      ))
    }

@delegate:ResourceContentHash(964_698_987)
internal val Res.string.streak_restoration_confirm_btn: StringResource by lazy {
      StringResource("string:streak_restoration_confirm_btn", "streak_restoration_confirm_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263332, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259908, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250636, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244360, 46),
      ))
    }

@delegate:ResourceContentHash(-1_795_356_660)
internal val Res.string.streak_restoration_confirm_message: StringResource by lazy {
      StringResource("string:streak_restoration_confirm_message", "streak_restoration_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263379, 186),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 259955, 170),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250679, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244407, 138),
      ))
    }

@delegate:ResourceContentHash(-430_951_493)
internal val Res.string.streak_restoration_confirm_title: StringResource by lazy {
      StringResource("string:streak_restoration_confirm_title", "streak_restoration_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263566, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260126, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250846, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244546, 76),
      ))
    }

@delegate:ResourceContentHash(2_038_278_996)
internal val Res.string.streak_restoration_restorable_day_desc: StringResource by lazy {
      StringResource("string:streak_restoration_restorable_day_desc", "streak_restoration_restorable_day_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263651, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260215, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 250927, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244623, 118),
      ))
    }

@delegate:ResourceContentHash(-1_235_560_391)
internal val Res.string.tab_chapters: StringResource by lazy {
      StringResource("string:tab_chapters", "tab_chapters", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263790, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260350, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261619, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251062, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244742, 32),
      ))
    }

@delegate:ResourceContentHash(605_015_020)
internal val Res.string.tab_correggi: StringResource by lazy {
      StringResource("string:tab_correggi", "tab_correggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263823, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260387, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261652, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251095, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244775, 32),
      ))
    }

@delegate:ResourceContentHash(2_011_377_296)
internal val Res.string.tab_favorites: StringResource by lazy {
      StringResource("string:tab_favorites", "tab_favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263852, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260420, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261685, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251124, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244808, 45),
      ))
    }

@delegate:ResourceContentHash(-1_714_565_344)
internal val Res.string.tab_hieroglyphs: StringResource by lazy {
      StringResource("string:tab_hieroglyphs", "tab_hieroglyphs", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263936, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260508, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261765, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251212, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244892, 39),
      ))
    }

@delegate:ResourceContentHash(-1_151_980_431)
internal val Res.string.tab_hieroglyphs_short: StringResource by lazy {
      StringResource("string:tab_hieroglyphs_short", "tab_hieroglyphs_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263898, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260466, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261727, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251170, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244854, 37),
      ))
    }

@delegate:ResourceContentHash(222_925_375)
internal val Res.string.tab_images: StringResource by lazy {
      StringResource("string:tab_images", "tab_images", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 263976, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260544, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261809, 26),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251248, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244932, 26),
      ))
    }

@delegate:ResourceContentHash(-9_085_226)
internal val Res.string.tab_locked: StringResource by lazy {
      StringResource("string:tab_locked", "tab_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264003, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260575, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261836, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251279, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244959, 38),
      ))
    }

@delegate:ResourceContentHash(409_224_175)
internal val Res.string.tab_rules: StringResource by lazy {
      StringResource("string:tab_rules", "tab_rules", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264042, 25),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260618, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261883, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251318, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 244998, 25),
      ))
    }

@delegate:ResourceContentHash(-419_746_121)
internal val Res.string.tab_unlocked: StringResource by lazy {
      StringResource("string:tab_unlocked", "tab_unlocked", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264068, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260644, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261913, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251344, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245024, 40),
      ))
    }

@delegate:ResourceContentHash(2_060_923_474)
internal val Res.string.tab_words: StringResource by lazy {
      StringResource("string:tab_words", "tab_words", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264117, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260693, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261958, 25),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251389, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245065, 25),
      ))
    }

@delegate:ResourceContentHash(501_874_379)
internal val Res.string.terms_and_conditions_label: StringResource by lazy {
      StringResource("string:terms_and_conditions_label", "terms_and_conditions_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264147, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260723, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 261984, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251415, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245091, 62),
      ))
    }

@delegate:ResourceContentHash(-879_661_862)
internal val Res.string.test_mode_desc: StringResource by lazy {
      StringResource("string:test_mode_desc", "test_mode_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264210, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260790, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262051, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251478, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245154, 70),
      ))
    }

@delegate:ResourceContentHash(1_981_651_306)
internal val Res.string.test_mode_title: StringResource by lazy {
      StringResource("string:test_mode_title", "test_mode_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264289, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260893, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262138, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251557, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245225, 35),
      ))
    }

@delegate:ResourceContentHash(-116_568_920)
internal val Res.string.three_errors_feedback: StringResource by lazy {
      StringResource("string:three_errors_feedback", "three_errors_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264325, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260937, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262174, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251601, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245261, 37),
      ))
    }

@delegate:ResourceContentHash(467_610_373)
internal val Res.string.three_errors_subtitle: StringResource by lazy {
      StringResource("string:three_errors_subtitle", "three_errors_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264367, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 260979, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262216, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251639, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245299, 69),
      ))
    }

@delegate:ResourceContentHash(-1_754_150_778)
internal val Res.string.toggle_favorite_desc: StringResource by lazy {
      StringResource("string:toggle_favorite_desc", "toggle_favorite_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264437, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261053, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262290, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251705, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245369, 48),
      ))
    }

@delegate:ResourceContentHash(1_700_361_219)
internal val Res.string.top_bar_coin_desc: StringResource by lazy {
      StringResource("string:top_bar_coin_desc", "top_bar_coin_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264490, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261126, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262343, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251778, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245418, 33),
      ))
    }

@delegate:ResourceContentHash(-547_479_087)
internal val Res.string.top_bar_fire_desc: StringResource by lazy {
      StringResource("string:top_bar_fire_desc", "top_bar_fire_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264524, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261160, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262377, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251816, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245452, 33),
      ))
    }

@delegate:ResourceContentHash(-1_716_379_345)
internal val Res.string.top_bar_heart_desc: StringResource by lazy {
      StringResource("string:top_bar_heart_desc", "top_bar_heart_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264558, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261194, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262411, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251854, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245486, 34),
      ))
    }

@delegate:ResourceContentHash(-397_476_839)
internal val Res.string.top_bar_star_desc: StringResource by lazy {
      StringResource("string:top_bar_star_desc", "top_bar_star_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264593, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261233, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262446, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251889, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245521, 33),
      ))
    }

@delegate:ResourceContentHash(-1_593_919_389)
internal val Res.string.triangle_desc: StringResource by lazy {
      StringResource("string:triangle_desc", "triangle_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264627, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261271, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262484, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251923, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245555, 33),
      ))
    }

@delegate:ResourceContentHash(-536_906_918)
internal val Res.string.true_option: StringResource by lazy {
      StringResource("string:true_option", "true_option", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264661, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261309, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262518, 27),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251957, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245589, 27),
      ))
    }

@delegate:ResourceContentHash(-848_583_882)
internal val Res.string.unlock_all_lessons_btn: StringResource by lazy {
      StringResource("string:unlock_all_lessons_btn", "unlock_all_lessons_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264689, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261341, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262546, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 251985, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245617, 50),
      ))
    }

@delegate:ResourceContentHash(-833_737_857)
internal val Res.string.unlock_quiz_explanation_hint: StringResource by lazy {
      StringResource("string:unlock_quiz_explanation_hint", "unlock_quiz_explanation_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264752, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261400, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262605, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252040, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245668, 96),
      ))
    }

@delegate:ResourceContentHash(631_481_693)
internal val Res.string.unlock_quiz_hint: StringResource by lazy {
      StringResource("string:unlock_quiz_hint", "unlock_quiz_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264865, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261509, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262706, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252141, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245765, 80),
      ))
    }

@delegate:ResourceContentHash(1_118_198_530)
internal val Res.string.unlock_requirements_hint: StringResource by lazy {
      StringResource("string:unlock_requirements_hint", "unlock_requirements_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 264962, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261602, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262795, 168),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252226, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245846, 144),
      ))
    }

@delegate:ResourceContentHash(-7_270_615)
internal val Res.string.unlock_up_to_chapter_9_btn: StringResource by lazy {
      StringResource("string:unlock_up_to_chapter_9_btn", "unlock_up_to_chapter_9_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265131, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261767, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262964, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252383, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245991, 66),
      ))
    }

@delegate:ResourceContentHash(677_041_646)
internal val Res.string.user_data_title: StringResource by lazy {
      StringResource("string:user_data_title", "user_data_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265206, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261842, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263043, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252454, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246058, 35),
      ))
    }

@delegate:ResourceContentHash(-1_778_691_887)
internal val Res.string.wait_tomorrow_hearts_label: StringResource by lazy {
      StringResource("string:wait_tomorrow_hearts_label", "wait_tomorrow_hearts_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265250, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261890, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263095, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252494, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246094, 74),
      ))
    }

@delegate:ResourceContentHash(-410_226_390)
internal val Res.string.walkthrough_text: StringResource by lazy {
      StringResource("string:walkthrough_text", "walkthrough_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266038, 268),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262658, 260),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263887, 300),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253202, 280),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246794, 232),
      ))
    }

@delegate:ResourceContentHash(-1_117_554_266)
internal val Res.string.walkthrough_text_builder: StringResource by lazy {
      StringResource("string:walkthrough_text_builder", "walkthrough_text_builder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265333, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 261973, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263174, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252573, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246169, 108),
      ))
    }

@delegate:ResourceContentHash(-901_842_219)
internal val Res.string.walkthrough_text_compendio: StringResource by lazy {
      StringResource("string:walkthrough_text_compendio", "walkthrough_text_compendio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265458, 238),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262114, 214),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263319, 218),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252686, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246278, 210),
      ))
    }

@delegate:ResourceContentHash(-97_729_605)
internal val Res.string.walkthrough_text_personaggi: StringResource by lazy {
      StringResource("string:walkthrough_text_personaggi", "walkthrough_text_personaggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265697, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262329, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263538, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 252877, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246489, 143),
      ))
    }

@delegate:ResourceContentHash(-36_109_179)
internal val Res.string.walkthrough_text_profile: StringResource by lazy {
      StringResource("string:walkthrough_text_profile", "walkthrough_text_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 265837, 200),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262469, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 263682, 204),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253017, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246633, 160),
      ))
    }

@delegate:ResourceContentHash(1_408_492_747)
internal val Res.string.walkthrough_unlock_builder: StringResource by lazy {
      StringResource("string:walkthrough_unlock_builder", "walkthrough_unlock_builder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266307, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 262919, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264188, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253483, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247027, 106),
      ))
    }

@delegate:ResourceContentHash(-404_307_254)
internal val Res.string.walkthrough_unlock_compendio: StringResource by lazy {
      StringResource("string:walkthrough_unlock_compendio", "walkthrough_unlock_compendio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266430, 188),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263050, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264319, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253606, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247134, 148),
      ))
    }

@delegate:ResourceContentHash(-571_612_415)
internal val Res.string.walkthrough_unlock_personaggi: StringResource by lazy {
      StringResource("string:walkthrough_unlock_personaggi", "walkthrough_unlock_personaggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266619, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263199, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264496, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253755, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247283, 129),
      ))
    }

@delegate:ResourceContentHash(1_501_729_225)
internal val Res.string.walkthrough_unlock_title: StringResource by lazy {
      StringResource("string:walkthrough_unlock_title", "walkthrough_unlock_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266769, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263345, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264658, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253897, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247413, 52),
      ))
    }

@delegate:ResourceContentHash(-1_804_999_034)
internal val Res.string.walkthrough_welcome_builder: StringResource by lazy {
      StringResource("string:walkthrough_welcome_builder", "walkthrough_welcome_builder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266830, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263406, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264727, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 253954, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247466, 67),
      ))
    }

@delegate:ResourceContentHash(-1_115_624_535)
internal val Res.string.walkthrough_welcome_compendio: StringResource by lazy {
      StringResource("string:walkthrough_welcome_compendio", "walkthrough_welcome_compendio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266898, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263498, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264799, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254026, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247534, 73),
      ))
    }

@delegate:ResourceContentHash(1_846_519_748)
internal val Res.string.walkthrough_welcome_personaggi: StringResource by lazy {
      StringResource("string:walkthrough_welcome_personaggi", "walkthrough_welcome_personaggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 266972, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263588, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264877, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254096, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247608, 78),
      ))
    }

@delegate:ResourceContentHash(606_889_474)
internal val Res.string.walkthrough_welcome_profile: StringResource by lazy {
      StringResource("string:walkthrough_welcome_profile", "walkthrough_welcome_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267051, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263695, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 264976, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254179, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247687, 67),
      ))
    }

@delegate:ResourceContentHash(2_074_121_226)
internal val Res.string.walkthrough_welcome_title: StringResource by lazy {
      StringResource("string:walkthrough_welcome_title", "walkthrough_welcome_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267127, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263783, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265048, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254251, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247755, 61),
      ))
    }

@delegate:ResourceContentHash(100_607_089)
internal val Res.string.what_happened_title: StringResource by lazy {
      StringResource("string:what_happened_title", "what_happened_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267193, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263865, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265114, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254317, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247817, 47),
      ))
    }

@delegate:ResourceContentHash(1_868_130_090)
internal val Res.string.widget_quiz_time: StringResource by lazy {
      StringResource("string:widget_quiz_time", "widget_quiz_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267245, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263909, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265170, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254361, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247865, 40),
      ))
    }

@delegate:ResourceContentHash(1_868_130_090)
internal val Res.string.widget_today_cta: StringResource by lazy {
      StringResource("string:widget_today_cta", "widget_today_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267298, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 263958, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265227, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254406, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247906, 40),
      ))
    }

@delegate:ResourceContentHash(781_549_492)
internal val Res.string.widget_today_done: StringResource by lazy {
      StringResource("string:widget_today_done", "widget_today_done", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267351, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264007, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265284, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254451, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247947, 49),
      ))
    }

@delegate:ResourceContentHash(-428_014_109)
internal val Res.string.word_bank_object_plural: StringResource by lazy {
      StringResource("string:word_bank_object_plural", "word_bank_object_plural", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267413, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264057, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265350, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254505, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247997, 47),
      ))
    }

@delegate:ResourceContentHash(1_509_522_373)
internal val Res.string.word_bank_object_singular: StringResource by lazy {
      StringResource("string:word_bank_object_singular", "word_bank_object_singular", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267461, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264105, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265398, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254553, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248045, 45),
      ))
    }

@delegate:ResourceContentHash(1_664_385_836)
internal val Res.string.word_bank_subject_plural: StringResource by lazy {
      StringResource("string:word_bank_subject_plural", "word_bank_subject_plural", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267507, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264151, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265444, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254599, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248091, 52),
      ))
    }

@delegate:ResourceContentHash(-510_071_442)
internal val Res.string.word_bank_subject_singular: StringResource by lazy {
      StringResource("string:word_bank_subject_singular", "word_bank_subject_singular", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267560, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264200, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265493, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254652, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248144, 46),
      ))
    }

@delegate:ResourceContentHash(2_091_630_647)
internal val Res.string.word_not_seen_hint: StringResource by lazy {
      StringResource("string:word_not_seen_hint", "word_not_seen_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267607, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264247, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265540, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254703, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248191, 74),
      ))
    }

@delegate:ResourceContentHash(-1_196_901_560)
internal val Res.string.word_spelling_correct_word_label: StringResource by lazy {
      StringResource("string:word_spelling_correct_word_label", "word_spelling_correct_word_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267690, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264334, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265627, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254790, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248266, 64),
      ))
    }

@delegate:ResourceContentHash(-1_238_891_963)
internal val Res.string.word_unknown_title: StringResource by lazy {
      StringResource("string:word_unknown_title", "word_unknown_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267755, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264403, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265692, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254859, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248331, 42),
      ))
    }

@delegate:ResourceContentHash(1_389_747_262)
internal val Res.string.wrong_feedback_1: StringResource by lazy {
      StringResource("string:wrong_feedback_1", "wrong_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267806, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264458, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265735, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254910, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248374, 52),
      ))
    }

@delegate:ResourceContentHash(1_470_596_602)
internal val Res.string.wrong_feedback_2: StringResource by lazy {
      StringResource("string:wrong_feedback_2", "wrong_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 267867, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 264527, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 265800, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 254971, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248427, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString25Resources(map: MutableMap<String, StringResource>) {
  map.put("send_feedback_btn", Res.string.send_feedback_btn)
  map.put("share_btn_text", Res.string.share_btn_text)
  map.put("share_builder", Res.string.share_builder)
  map.put("share_quiz_hiero", Res.string.share_quiz_hiero)
  map.put("share_quiz_multi", Res.string.share_quiz_multi)
  map.put("share_quiz_spelling", Res.string.share_quiz_spelling)
  map.put("share_quiz_transcribe", Res.string.share_quiz_transcribe)
  map.put("share_quiz_translate", Res.string.share_quiz_translate)
  map.put("share_quiz_true_false", Res.string.share_quiz_true_false)
  map.put("share_quiz_word", Res.string.share_quiz_word)
  map.put("share_streak_many", Res.string.share_streak_many)
  map.put("share_streak_one", Res.string.share_streak_one)
  map.put("share_title", Res.string.share_title)
  map.put("shop", Res.string.shop)
  map.put("stat_desc_coin", Res.string.stat_desc_coin)
  map.put("stat_desc_heart", Res.string.stat_desc_heart)
  map.put("stat_desc_star", Res.string.stat_desc_star)
  map.put("stat_desc_strike", Res.string.stat_desc_strike)
  map.put("stat_title_coin", Res.string.stat_title_coin)
  map.put("stat_title_heart", Res.string.stat_title_heart)
  map.put("stat_title_star", Res.string.stat_title_star)
  map.put("stat_title_strike", Res.string.stat_title_strike)
  map.put("streak_restoration_banner_hint", Res.string.streak_restoration_banner_hint)
  map.put("streak_restoration_banner_many", Res.string.streak_restoration_banner_many)
  map.put("streak_restoration_banner_one", Res.string.streak_restoration_banner_one)
  map.put("streak_restoration_confirm_btn", Res.string.streak_restoration_confirm_btn)
  map.put("streak_restoration_confirm_message", Res.string.streak_restoration_confirm_message)
  map.put("streak_restoration_confirm_title", Res.string.streak_restoration_confirm_title)
  map.put("streak_restoration_restorable_day_desc", Res.string.streak_restoration_restorable_day_desc)
  map.put("tab_chapters", Res.string.tab_chapters)
  map.put("tab_correggi", Res.string.tab_correggi)
  map.put("tab_favorites", Res.string.tab_favorites)
  map.put("tab_hieroglyphs", Res.string.tab_hieroglyphs)
  map.put("tab_hieroglyphs_short", Res.string.tab_hieroglyphs_short)
  map.put("tab_images", Res.string.tab_images)
  map.put("tab_locked", Res.string.tab_locked)
  map.put("tab_rules", Res.string.tab_rules)
  map.put("tab_unlocked", Res.string.tab_unlocked)
  map.put("tab_words", Res.string.tab_words)
  map.put("terms_and_conditions_label", Res.string.terms_and_conditions_label)
  map.put("test_mode_desc", Res.string.test_mode_desc)
  map.put("test_mode_title", Res.string.test_mode_title)
  map.put("three_errors_feedback", Res.string.three_errors_feedback)
  map.put("three_errors_subtitle", Res.string.three_errors_subtitle)
  map.put("toggle_favorite_desc", Res.string.toggle_favorite_desc)
  map.put("top_bar_coin_desc", Res.string.top_bar_coin_desc)
  map.put("top_bar_fire_desc", Res.string.top_bar_fire_desc)
  map.put("top_bar_heart_desc", Res.string.top_bar_heart_desc)
  map.put("top_bar_star_desc", Res.string.top_bar_star_desc)
  map.put("triangle_desc", Res.string.triangle_desc)
  map.put("true_option", Res.string.true_option)
  map.put("unlock_all_lessons_btn", Res.string.unlock_all_lessons_btn)
  map.put("unlock_quiz_explanation_hint", Res.string.unlock_quiz_explanation_hint)
  map.put("unlock_quiz_hint", Res.string.unlock_quiz_hint)
  map.put("unlock_requirements_hint", Res.string.unlock_requirements_hint)
  map.put("unlock_up_to_chapter_9_btn", Res.string.unlock_up_to_chapter_9_btn)
  map.put("user_data_title", Res.string.user_data_title)
  map.put("wait_tomorrow_hearts_label", Res.string.wait_tomorrow_hearts_label)
  map.put("walkthrough_text", Res.string.walkthrough_text)
  map.put("walkthrough_text_builder", Res.string.walkthrough_text_builder)
  map.put("walkthrough_text_compendio", Res.string.walkthrough_text_compendio)
  map.put("walkthrough_text_personaggi", Res.string.walkthrough_text_personaggi)
  map.put("walkthrough_text_profile", Res.string.walkthrough_text_profile)
  map.put("walkthrough_unlock_builder", Res.string.walkthrough_unlock_builder)
  map.put("walkthrough_unlock_compendio", Res.string.walkthrough_unlock_compendio)
  map.put("walkthrough_unlock_personaggi", Res.string.walkthrough_unlock_personaggi)
  map.put("walkthrough_unlock_title", Res.string.walkthrough_unlock_title)
  map.put("walkthrough_welcome_builder", Res.string.walkthrough_welcome_builder)
  map.put("walkthrough_welcome_compendio", Res.string.walkthrough_welcome_compendio)
  map.put("walkthrough_welcome_personaggi", Res.string.walkthrough_welcome_personaggi)
  map.put("walkthrough_welcome_profile", Res.string.walkthrough_welcome_profile)
  map.put("walkthrough_welcome_title", Res.string.walkthrough_welcome_title)
  map.put("what_happened_title", Res.string.what_happened_title)
  map.put("widget_quiz_time", Res.string.widget_quiz_time)
  map.put("widget_today_cta", Res.string.widget_today_cta)
  map.put("widget_today_done", Res.string.widget_today_done)
  map.put("word_bank_object_plural", Res.string.word_bank_object_plural)
  map.put("word_bank_object_singular", Res.string.word_bank_object_singular)
  map.put("word_bank_subject_plural", Res.string.word_bank_subject_plural)
  map.put("word_bank_subject_singular", Res.string.word_bank_subject_singular)
  map.put("word_not_seen_hint", Res.string.word_not_seen_hint)
  map.put("word_spelling_correct_word_label", Res.string.word_spelling_correct_word_label)
  map.put("word_unknown_title", Res.string.word_unknown_title)
  map.put("wrong_feedback_1", Res.string.wrong_feedback_1)
  map.put("wrong_feedback_2", Res.string.wrong_feedback_2)
}
